/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/* prettier-ignore */


export enum VerizonFusfExemptionType {
    Exempt = 'E',
    NotExempt = 'N',
}